import { Divider, Grid, Typography } from '@mui/material';
import { SummaryLabel } from 'src/components/accordion/SidebarAccordion.styled';

import { ColorShadesProps, ShadesValue } from './ColorButtonGroup.interface';
import {
  StyledShadeToggleButton,
  StyledToggleButtonGroup,
} from './ColorButtonGroup.styled';

export const ColorButtonGroup = ({
  label,
  value,
  colorOptions,
  onChange,
}: ColorShadesProps) => {
  return (
    <Grid item xs={12}>
      {label && (
        <>
          <SummaryLabel>{label}</SummaryLabel>
          <Divider />
        </>
      )}
      <StyledToggleButtonGroup
        orientation="vertical"
        value={value}
        exclusive
        onChange={(_: any, value: string) => onChange(value)}>
        {colorOptions.map((color: ShadesValue) => (
          <StyledShadeToggleButton value={color.value} key={color.value}>
            <Grid item container flexDirection="row" xs={12}>
              <Grid
                item
                xs={2}
                sx={{ background: color.shadeValue, border: 1 }}
              />
              <Grid
                item
                container
                flexDirection="column"
                alignItems="flex-start"
                xs={10}
                p={2}>
                <Typography variant="caption" display="block">
                  {color.colorTitle}
                </Typography>
                <Typography variant="caption" display="block">
                  {color.colorValue}
                </Typography>
              </Grid>
            </Grid>
          </StyledShadeToggleButton>
        ))}
      </StyledToggleButtonGroup>
    </Grid>
  );
};
